export const parseHeight = (height) => {
  return (height / 10).toFixed(2)
}

export const parseWeight = (weight) => {
  return (weight / 10).toFixed(2)
}
